<template>
  <div class="bg-white px-10 py-5 rounded-lg md:mx-10 ">
    <div class="flex pb-3">
      <d-icon class="text-secondary-500" size="lg" icon="list" />
      <p class="px-3 font-bold">
        My Assigned Items
      </p>
    </div>
    <div class="pt-3">
      <div v-if="todos.length > 0">
        <div v-for="todo in todos" :key="todo.id" class="pb-2 cursor-pointer" @click="gotoTodo(todo)">
          <p class="font-bold">
            {{ todo.type }}: {{ todo.name }} <span v-if="todo.userId != profile.id" class="text-secondary-500">(for review)</span>
          </p>
          <p>
            Due: {{ todo.dueDate | formatShortDate }}
          </p>
          <div v-if="!todo.submitted">
            <span v-if="todo.overdue" class="text-error">
              Overdue!
            </span>
            <span v-else-if="todo.dueSoon" class="text-error">
              Due soon!
            </span>
          </div>
          <div v-else>
            <span>Pending Review</span>
          </div>

          <p class="text-gray-600 text-sm">
            <span v-if="todo.userId != profile.id">{{ todo.userFullName }}</span>
            <span v-else>Assigned to me</span>
          </p>
          <hr>
        </div>
      </div>
      <div v-else>
        No tasks currently assigned
      </div>
      <div>
        <a href="/assignments">View all assignments</a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import axios from 'axios';

  export default {
    name: 'ToDoComponent',
    parent: true,
    components: {

    },

    data: () => ({
      todos: [],
    }),

    computed: {
      ...mapGetters('d2Auth', ['profile']),
    },

    mounted() {
      this.getTodos();
    },
    methods: {
      async getTodos() {
        const { data } = await axios.get('/api/gateway/todos');
        this.todos = data;
      },
      gotoTodo(todo) {
        if (todo.type === 'ToDo') {
          window.location = `/assignments/todo/${todo.id}`;
        } else {
          window.location = `/assignments/${todo.id}`;
        }
      },
    },
  };
</script>